import React from 'react';
import OpsRoomDashboard from './components/OpsRoomDashboard';

export default function App() {
  return <OpsRoomDashboard />;
}
